/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeLanguage } from './CodeLanguage';
import {
    CodeLanguageFromJSON,
    CodeLanguageFromJSONTyped,
    CodeLanguageToJSON,
    CodeLanguageToJSONTyped,
} from './CodeLanguage';
import type { ProblemType } from './ProblemType';
import {
    ProblemTypeFromJSON,
    ProblemTypeFromJSONTyped,
    ProblemTypeToJSON,
    ProblemTypeToJSONTyped,
} from './ProblemType';
import type { CompetitionSummary } from './CompetitionSummary';
import {
    CompetitionSummaryFromJSON,
    CompetitionSummaryFromJSONTyped,
    CompetitionSummaryToJSON,
    CompetitionSummaryToJSONTyped,
} from './CompetitionSummary';

/**
 * A problem as the list, create, update and tag endpoints return it: no solution code.
 * @export
 * @interface ProblemRead
 */
export interface ProblemRead {
    /**
     * 
     * @type {string}
     * @memberof ProblemRead
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemRead
     */
    ordinal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemRead
     */
    statement: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemRead
     */
    points: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemRead
     */
    time_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemRead
     */
    complexity?: number | null;
    /**
     * Whether problem is publicly visible (True) or private (False)
     * @type {boolean}
     * @memberof ProblemRead
     */
    is_public?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProblemRead
     */
    owner_id?: string | null;
    /**
     * 
     * @type {ProblemType}
     * @memberof ProblemRead
     */
    problem_type: ProblemType;
    /**
     * 
     * @type {CodeLanguage}
     * @memberof ProblemRead
     */
    solution_language: CodeLanguage;
    /**
     * 
     * @type {string}
     * @memberof ProblemRead
     */
    id: string;
    /**
     * All test cases of the problem
     * @type {number}
     * @memberof ProblemRead
     */
    test_cases_count?: number;
    /**
     * Test cases with the example visibility
     * @type {number}
     * @memberof ProblemRead
     */
    example_count?: number;
    /**
     * Test cases whose official output is prepared (initialized)
     * @type {number}
     * @memberof ProblemRead
     */
    prepared_test_cases_count?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProblemRead
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<CompetitionSummary>}
     * @memberof ProblemRead
     */
    competitions?: Array<CompetitionSummary>;
}



/**
 * Check if a given object implements the ProblemRead interface.
 */
export function instanceOfProblemRead(value: object): value is ProblemRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('statement' in value) || value['statement'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('problem_type' in value) || value['problem_type'] === undefined) return false;
    if (!('solution_language' in value) || value['solution_language'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ProblemReadFromJSON(json: any): ProblemRead {
    return ProblemReadFromJSONTyped(json, false);
}

export function ProblemReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProblemRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'statement': json['statement'],
        'points': json['points'],
        'time_limit': json['time_limit'] == null ? undefined : json['time_limit'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'owner_id': json['owner_id'] == null ? undefined : json['owner_id'],
        'problem_type': ProblemTypeFromJSON(json['problem_type']),
        'solution_language': CodeLanguageFromJSON(json['solution_language']),
        'id': json['id'],
        'test_cases_count': json['test_cases_count'] == null ? undefined : json['test_cases_count'],
        'example_count': json['example_count'] == null ? undefined : json['example_count'],
        'prepared_test_cases_count': json['prepared_test_cases_count'] == null ? undefined : json['prepared_test_cases_count'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'competitions': json['competitions'] == null ? undefined : ((json['competitions'] as Array<any>).map(CompetitionSummaryFromJSON)),
    };
}

export function ProblemReadToJSON(json: any): ProblemRead {
    return ProblemReadToJSONTyped(json, false);
}

export function ProblemReadToJSONTyped(value?: ProblemRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'statement': value['statement'],
        'points': value['points'],
        'time_limit': value['time_limit'],
        'complexity': value['complexity'],
        'is_public': value['is_public'],
        'owner_id': value['owner_id'],
        'problem_type': ProblemTypeToJSON(value['problem_type']),
        'solution_language': CodeLanguageToJSON(value['solution_language']),
        'id': value['id'],
        'test_cases_count': value['test_cases_count'],
        'example_count': value['example_count'],
        'prepared_test_cases_count': value['prepared_test_cases_count'],
        'tags': value['tags'],
        'competitions': value['competitions'] == null ? undefined : ((value['competitions'] as Array<any>).map(CompetitionSummaryToJSON)),
    };
}

